export default __webpack_public_path__ + "static/media/succsess-int.7d825d1b.svg";